import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './AdminUploadFile.css';

const ADMIN_ROOT = process.env.REACT_APP_START_PATH || '/admin';

function AdminUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={ADMIN_ROOT}
      sessionPrefix="admin_file"
    />
  );
}

AdminUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default AdminUploadFile;
